import React from 'react'

const Contact = () => {
  return (
    <div name='contact' className='w-full h-screen bg-[#0a192f] flex justify-center items-center p-4'>
        <form method='POST' action="https://getform.io/f/62be7beb-d58b-4920-bf92-00aee3b166ea" className='flex flex-col max-w-[600px] w-full'>
            <div className='pb-8'>
                <p className='text-5xl font-bold inline border-b-4 border-purple-600 py-1 text-gray-300'>Contact</p>
                <p className='text-gray-300 font-bold py-5 text-lg'>Complete the form or send me an email - andazo2501@gmail.com</p>
            </div>
            <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
            <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
            <textarea className='bg-[#ccd6f6] p-2' name="message" rows="10" placeholder='Message'></textarea>
            <button className='text-white border-2 hover:bg-purple-600 hover:border-purple-600 px-4 py-3 my-8 mx-auto flex items-center'>Send Message</button>
        </form>
    </div>
  )
}

export default Contact